import React from "react";
import styles from "./DanceGallery.module.css";

const DanceGallery = () => {
  const courses = [
    {
      id: 1,
      name: "Bharatnatyam",
      description: "Ancient Indian classical dance form with intricate movements and spiritual significance. Perfect for those seeking to connect with classical Indian culture.",
      icon: "🎭",
      duration: "12 weeks",
      level: "All Levels",
      schedule: "Tue & Fri, 6-7:30 PM",
    },
    {
      id: 2,
      name: "Kathak",
      description: "North Indian classical dance emphasizing rhythmic patterns and storytelling. Features rapid footwork and expressive hand gestures.",
      icon: "💫",
      duration: "12 weeks",
      level: "All Levels",
      schedule: "Mon & Wed, 7-8:30 PM",
    },
    {
      id: 3,
      name: "Bollywood",
      description: "Contemporary dance style inspired by Bollywood choreography. Learn vibrant moves, hip movements, and energetic sequences.",
      icon: "✨",
      duration: "8 weeks",
      level: "Beginner to Intermediate",
      schedule: "Sat, 2-3:30 PM",
    }
  ];

  return (
    <div className={styles.danceCourseContainer}>
      <header className={styles.danceCourseHeader} style={{ paddingTop: "100px" }}>
        <h1 style={{ fontSize: "3rem", marginBottom: "20px", fontWeight: 700 }}>
          Discover Our <span style={{ color: "#ff8c00" }}>Dance Programs</span>
        </h1>
        <p style={{ fontSize: "1.1rem", color: "#666", maxWidth: "700px", margin: "0 auto" }}>
          Learn from expert instructors in authentic Indian classical and contemporary dance forms. Each course is designed to build technique, confidence, and artistic expression.
        </p>
      </header>

      <div style={{
        maxWidth: "1200px",
        margin: "80px auto",
        padding: "0 20px"
      }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "40px"
        }}>
          {courses.map((course) => (
            <div
              key={course.id}
              style={{
                background: "white",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                const elem = e.currentTarget;
                elem.style.transform = "translateY(-10px)";
                elem.style.boxShadow = "0 20px 50px rgba(255, 140, 0, 0.2)";
              }}
              onMouseLeave={(e) => {
                const elem = e.currentTarget;
                elem.style.transform = "translateY(0)";
                elem.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.1)";
              }}
            >
              {/* Course Icon Background */}
              <div style={{
                background: "linear-gradient(135deg, #ff8c00 0%, #ffa500 100%)",
                padding: "40px 20px",
                textAlign: "center",
                fontSize: "3rem"
              }}>
                {course.icon}
              </div>

              {/* Course Content */}
              <div style={{ padding: "30px" }}>
                <h2 style={{
                  fontSize: "1.8rem",
                  color: "#1a1a1a",
                  marginBottom: "15px",
                  fontWeight: 700
                }}>
                  {course.name}
                </h2>

                <p style={{
                  color: "#555",
                  fontSize: "0.95rem",
                  lineHeight: "1.6",
                  marginBottom: "25px"
                }}>
                  {course.description}
                </p>

                {/* Course Details */}
                <div style={{
                  background: "#f8f9fa",
                  padding: "20px",
                  borderRadius: "10px",
                  marginBottom: "25px"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                    <span style={{ color: "#666", fontWeight: 600 }}>Duration:</span>
                    <span style={{ color: "#ff8c00", fontWeight: 600 }}>{course.duration}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                    <span style={{ color: "#666", fontWeight: 600 }}>Level:</span>
                    <span style={{ color: "#ff8c00", fontWeight: 600 }}>{course.level}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span style={{ color: "#666", fontWeight: 600 }}>Schedule:</span>
                    <span style={{ color: "#ff8c00", fontWeight: 600 }}>{course.schedule}</span>
                  </div>
                </div>

                {/* Enrollment Button */}
                <button style={{
                  width: "100%",
                  padding: "12px",
                  background: "#ff8c00",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "1rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#e67e00";
                  e.currentTarget.style.transform = "scale(1.02)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#ff8c00";
                  e.currentTarget.style.transform = "scale(1)";
                }}>
                  Enroll Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Gallery Link */}
        <div style={{
          marginTop: "80px",
          textAlign: "center",
          padding: "60px 40px",
          background: "#f8f9fa",
          borderRadius: "16px"
        }}>
          <h2 style={{
            fontSize: "2rem",
            color: "#1a1a1a",
            marginBottom: "20px"
          }}>
            See Our Students in Action
          </h2>
          <p style={{
            color: "#666",
            fontSize: "1rem",
            marginBottom: "30px",
            maxWidth: "600px",
            margin: "0 auto 30px"
          }}>
            Browse our extensive collection of student performances, recitals, and competition moments. Get inspired by the talent and dedication of our dance community.
          </p>
          <a href="/dance-gallery" style={{
            display: "inline-block",
            padding: "12px 40px",
            background: "#ff8c00",
            color: "white",
            textDecoration: "none",
            borderRadius: "8px",
            fontWeight: 600,
            transition: "all 0.3s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#e67e00";
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 140, 0, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#ff8c00";
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}>
            View Dance Gallery
          </a>
        </div>
      </div>
    </div>
  );
};

export default DanceGallery;
